import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MerchantAccount, MerchantAccountType } from '../../models';
import { MerchantAccountService } from '../../services';
import { MerchantAccountNameValidator } from '../../validators';

@Component({
    selector: 'app-set-merchant-id',
    templateUrl: './set-merchant-id.component.html',
    styleUrls: ['./set-merchant-id.component.css']
})
export class SetMerchantIdComponent implements OnInit {

    @Input()
    merchantAccount: MerchantAccount;

    isCashnet: boolean;
    maxlength: number;
    saving = false;
    showErrors = false;
    setMerchantIdForm: FormGroup;
    get merchantId(): AbstractControl {
        return this.setMerchantIdForm.get('merchantId');
    }

    constructor(
        private readonly fb: FormBuilder,
        public activeModal: NgbActiveModal,
        private readonly toastr: ToastrService,
        private readonly merchantAccountService: MerchantAccountService,
    ) {
    }

    ngOnInit() {
        this.isCashnet = this.merchantAccount.merchantAccountType === MerchantAccountType.Cashnet;
        this.maxlength = this.isCashnet ? 10 : 25;
        this.setMerchantIdForm = this.fb.group({
            merchantId: [this.merchantAccount.merchantId, [Validators.required], [MerchantAccountNameValidator.validate(this.merchantAccountService, this.merchantAccount.id)]]
        });
    }

    onSave() {
        console.log(this.setMerchantIdForm);
        if (this.setMerchantIdForm.valid) {
            this.saving = true;
            this.merchantAccountService.setMerchantId(this.setMerchantIdForm.value, this.merchantAccount.id).subscribe(
                () => {
                    this.toastr.success(`The ${this.isCashnet ? "Location" : "Merchant"} ID was successfully saved!`);
                    this.saving = false;
                    this.activeModal.close();
                },
                err => {
                    this.saving = false;
                    throw err;
                });
        } else {
            this.showErrors = true;
        }
    }
}